export enum FlowTypes {
    LEGACY = "legacy",
    LSID = "lsid",
    SSO = "sso",
}

export enum ErrorTypes {
    LSID_MISSING_ROOT_URL = "LSID_MISSING_ROOT_URL",
    LSID_FEATURE_DISABLED = "LSID_FEATURE_DISABLED",
    LSID_MISSING_EMAIL = "LSID_MISSING_EMAIL",
    LSID_NOT_AUTHORIZED = "LSID_NOT_AUTHORIZED",
    LSID_INVALID_LOGIN = "LSID_INVALID_LOGIN",
    LSID_GENERAL_ERROR = "LSID_GENERAL_ERROR",
}
